const ROLES = {
  admin: 'admin',
  internalStaff: 'internal_staff',
  totem: 'totem',
  guest: 'guest',
  visionGroupPartecipant: 'vision_groups_client'
}

/**
 * returns the user object with some helper methods to check the roles, like:
 * isAdmin(), isInternalStaff(), etc..
*/
const getUser = ctx => {
  const userObject = { roles: [] }
  if (ctx.$auth.user) {
    userObject.roles = [...ctx.$auth.user.roles]
  }

  Object.entries(ROLES).forEach(([roleKey, roleValue]) => {
    let functionName = roleKey.charAt(0).toUpperCase() + roleKey.slice(1)
    functionName = `is${functionName}`
    userObject[functionName] = function() { return (this.roles || []).includes(roleValue) }
  })
  return userObject
}

const USER_ROLES_ALLOWED_NAVIGATION = {
  homepage: [ROLES.admin],
  gallery: [
    ROLES.admin,
    ROLES.totem,
    ROLES.guest,
    ROLES.internalStaff
  ],
  discovery: [
    ROLES.admin,
    ROLES.guest,
    ROLES.internalStaff
  ],
  vision_groups: [
    ROLES.visionGroupPartecipant
  ],
  search: [
    ROLES.admin,
    ROLES.guest,
    ROLES.internalStaff
  ]
}

export default ctx => ({
  user: () => getUser(ctx),

  afterLoginRedirectPath: () => {
    const user = getUser(ctx)
    if (user.isTotem() || user.isAdmin() || user.isInternalStaff()) {
      return '/gallery'
    }

    if (user.isGuest()) {
      return '/discovery'
    }

    if (user.isVisionGroupPartecipant() && user.roles.length === 1) {
      return '/vision_groups'
    }

    return '/discovery'
  },

  canNavigateTo: (routeName) => {
    const user = getUser(ctx)
    const routNamePrefix = routeName.includes('-') ? routeName.split('-')[0] : routeName
    const rolesAllowed = USER_ROLES_ALLOWED_NAVIGATION[routNamePrefix] || []
    return (user.roles || []).some(role => rolesAllowed.includes(role))
  },

  canCloseGalleryVideo: () => {
    const user = getUser(ctx)
    return user.isGuest() || user.isAdmin()
  },

  hasAdminstrativeRole: () => {
    const user = getUser(ctx)
    return user.isInternalStaff() || user.isAdmin()
  },

  canExitFromGalleryPage: () => {
    const user = getUser(ctx)
    return user.isInternalStaff() || user.isAdmin() || user.isGuest()
  }
})
